import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import { query } from '../../../GraphQL/query/MyProfile.query';

import SideMenu from './SideMenu.mapper';

const profileConverter = (myProfile = {}) => ({
  displayName: myProfile.userDetails && myProfile.userDetails.firstName,
});

export default class SideMenuGQL extends Component {
  static propTypes = {};

  render() {
    return (
      <Query query={query}>
        {({ loading, error, data, client }) => {
          const myProfile = profileConverter((data && data.myProfile) || {});
          return <SideMenu {...this.props} myProfile={myProfile} />;
        }}
      </Query>
    );
  }
}
